import { Alert, Grid } from '@vapor/material'
import { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ReservationContext } from '../../../context/reservation-context'
import { Context } from '../../../context/reservation-context.types'
import { getResevationWarningMessage } from './check-in-utils'

type CheckInAlertProps = {
  context: Context
}

function CheckInAlertInner({ context }: CheckInAlertProps) {
  const { t } = useTranslation()

  const warning = useMemo(() => getResevationWarningMessage(t, context.checkInWarning), [t, JSON.stringify(context.checkInWarning)])

  if (warning)
    return (
      <Grid item xs={12}>
        <Alert severity="warning" variant="outlined">
          {warning}
        </Alert>
      </Grid>
    )
  else return <></>
}

export default function CheckInAlert() {
  const context = useContext(ReservationContext)
  return <CheckInAlertInner context={context} />
}
